import { useSuspenseBillingDetails } from '#api/billing.queries.ts';
import { trackError } from '#api/errors.ts';
import { BillingHistoryList } from '../billing-history-list/BillingHistoryList.tsx';

export function Invoices() {
  const invoices = useSuspenseBillingDetails().data.data.invoices;

  if (invoices === null) {
    trackError('Failed to load invoices on billing page');
    return <p className="p-md">We were unable to load your invoices at this time.</p>;
  }

  return invoices.length ?
      <section>
        <h2 className="h4 mb-0">Recent history</h2>
        <BillingHistoryList data={invoices} />
      </section>
    : null;
}
